export default [
  {
    path: '/flashdeal/privilege/campaign/list',
    name: 'flashdeal-privilege-campaign-list',
    component: () => import(
      '@/views/pages/flashdeal/privilege-campaign-list/PrivilegeCampaignList.vue'
    ),
    meta: {},
    breadcrumb: [
      {
        text: 'Flash Deal',
      },
      {
        text: 'Campaign List',
      },
      {
        text: 'Privilege',
        active: true,
      },
    ],
  },
  {
    path: '/flashdeal/privilege/campaign/create',
    name: 'flashdeal-privilege-campaign-create',
    component: () => import(
      '@/views/pages/flashdeal/privilege-campaign-info/PrivilegeCampaignInfo.vue'
    ),
    meta: {},
    breadcrumb: [
      {
        text: 'Flash Deal',
      },
      {
        text: 'Flash Deal List',
      },
      {
        text: 'Create Campaign',
        active: true,
      },
    ],
  },
  {
    path: '/flashdeal/privilege/campaign/info/:id/:ref',
    name: 'flashdeal-privilege-campaign-info',
    component: () => import(
      '@/views/pages/flashdeal/privilege-campaign-info/PrivilegeCampaignInfo.vue'
    ),
    meta: {},
    breadcrumb: [
      {
        text: 'Flash Deal',
      },
      {
        text: 'Flash Deal List',
      },
      {
        text: 'Edit Campaign',
        active: true,
      },
    ],
  },
]
